import { useFormContext } from "react-hook-form";
import Select from "@medoma/components/Select/Select";
import { useEconomicUnits } from "@/api/Patients";
import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { useLingui } from "@lingui/react/macro";
import type { SiteId } from "@medoma/models/sites";

export type EconomicUnitSelectFields = {
  economicUnitId: string;
};

const EconomicUnitSelect = ({ siteId }: { siteId: SiteId }) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<EconomicUnitSelectFields>();

  const {
    data: economicUnits,
    isPending: isPendingEconomicUnits,
    isError: isErrorEconomicUnits,
  } = useEconomicUnits(siteId, { enabled: true });

  if (isErrorEconomicUnits) {
    return (
      <ErrorMessage
        message={t`Kunde inte hämta ekonomisk enhet. Försök igen om en liten stund. Kontakta support om problemet kvarstår.`}
      />
    );
  }

  if (isPendingEconomicUnits) {
    return (
      <Select label={t`Ekonomisk enhet`} name="economicUnitId">
        <option>{t`Hämtar ekonomiska enheter`}...</option>
      </Select>
    );
  }

  if (economicUnits.length === 0) {
    return (
      <ErrorMessage
        message={t`Ingen ekonomisk enhet hittades. Försök igen om en liten stund. Kontakta support om problemet kvarstår.`}
      />
    );
  }

  return (
    <Select
      label={t`Ekonomisk enhet`}
      {...register("economicUnitId", {
        required: { value: true, message: t`Ange ekonomisk enhet` },
      })}
      errorMessage={errors.economicUnitId?.message}
    >
      {economicUnits.map((economicUnit) => (
        <option value={economicUnit.id} key={economicUnit.id}>
          {economicUnit.displayName}
        </option>
      ))}
    </Select>
  );
};

export default EconomicUnitSelect;
